import { Banner as CXBanner } from '@sanlamcx/react-ui-next-banner';

type Banner = typeof CXBanner;
export const Banner: Banner = CXBanner;
